import type { ModelDuplicateButtonProps } from "./model-duplicate-button.type";
import type { MouseEventHandler } from "react";

import { CopyOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useModelDuplicateSidePanel } from "../model-duplicate-side-panel";

const ModelDuplicateButton = ({
  modelKey,
  form,
  showIcon,
  onClick,
  ...buttonProps
}: ModelDuplicateButtonProps) => {
  const { t } = useTranslation();
  const { openDuplicate } = useModelDuplicateSidePanel(modelKey);

  const onButtonClick: MouseEventHandler<HTMLElement> = (e) => {
    onClick?.(e);
    openDuplicate(form);
  };

  return (
    <Button
      icon={showIcon ? <CopyOutlined /> : undefined}
      {...buttonProps}
      onClick={(e) => onButtonClick(e)}
    >
      {t("global:duplicate")}
    </Button>
  );
};

export default ModelDuplicateButton;
